<template>
  <div class="VerificationCode">
      <el-dialog title="验证码" :visible.sync="dialog" :before-close="close" width="372px">
         <div class="content">
              <el-input style="width: 220px" placeholder="请输入验证码" v-model="verificationCode" maxlength="4"></el-input>
                <img @click="getCode" :src="base64"/>
                <input style="width:0;height:0;border:none"/>
            <el-button type="primary" @click="postVerificationCode">{{btnname}}</el-button>   
         </div>
      </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {createCode} from 'api/gujingApi'
export default {
  name: 'VerificationCode',
  data () {
    return {
        dialog: false,
        btnname: '',
        verificationCode: '',
        base64: '',
        codeEncryption: ''
    }
  },
  mounted () {
      this.getCode()
  },
  methods: {
      close() {
          this.dialog = false
          this.verificationCode = ''
      },
      start(btnname) {
          this.getCode()
          this.dialog = true
          this.btnname = btnname
      },
      getCode() {
          this.setLoading(true)
          createCode({
              data: {},
              success: data => {
                   this.setLoading(false)
                   this.base64 = data.result.base64
                   this.codeEncryption = data.result.codeEncryption
                   console.log(data)
              },
              error: data => {
                  this.setLoading(false)
                  this.$message.error(data.msg)
              }
          })
      },
      postVerificationCode() {
          if (this.verificationCode.length == 0) {
              this.$message.info('验证码不能为空')
          } else {
              this.$emit('getVerificationCode', this.verificationCode, this.codeEncryption)
          }
      },
      ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.VerificationCode {
    .content {
        height: 120px;
        text-align: center;
        img {
            cursor: pointer;
            float: right;
        }
        .el-input {
            float: left;
        }
        .el-button {
            margin-top: 40px;
            width: 280px;
        }
    }
}

</style>